export type SubmitResult = {ok: true} | {ok: false; error: string};

export enum FormSubmitStatus {
  Idle = 'idle',
  Submitting = 'submitting',
  Error = 'error',
}
